module.exports = __webpack_public_path__ + "static/media/avani-white-logo.f974add6.png";